<template>
  <div :class="['widget', {'border-error': error}]">

    <v-container style="height: 100%;">
      <v-layout>
        <span class="subheading">
          Outages{{ state ? ` in ${state}` : "" }}
        </span>
      </v-layout>

      <template v-if="loading">
        <v-layout
          align-center
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else>
        <v-container style="padding: 12px 24px 0 24px;">
          <telstra
            @error="error = true"/>
          <vodafone/>
          <optus
            @error="error = true"/>
          <western-power
            v-if="state === 'WA'"
            @error="error = true"/>
          <tas-networks v-if="state === 'TAS'"/>
          <ausgrid v-if="state === 'NSW'"/>
          <essential-energy v-if="state === 'NSW'"/>
          <citypower-powercor v-if="state === 'VIC'"/>
          <endeavour-energy v-if="state === 'NSW'"/>
          <evo-energy v-if="state === 'ACT'"/>
          <power-water v-if="state === 'NT'"/>
          <energex v-if="state === 'QLD'"/>
          <sa-power-networks v-if="state === 'SA'"/>
        </v-container>
      </template>
    </v-container>

  </div>
</template>

<script>
import Ausgrid from "./Outages/Ausgrid.vue";
import CitypowerPowercor from "./Outages/CitypowerPowercor.vue";
import EndeavourEnergy from "./Outages/EndeavourEnergy.vue";
import EssentialEnergy from "./Outages/EssentialEnergy.vue";
import Energex from "./Outages/Energex.vue";
import EvoEnergy from "./Outages/EvoEnergy.vue";
import Optus from "./Outages/Optus.vue";
import PowerWater from "./Outages/PowerWater.vue";
import SaPowerNetworks from "./Outages/SAPowerNetworks.vue";
import TasNetworks from "./Outages/TasNetworks.vue";
import Telstra from "./Outages/Telstra.vue";
import Vodafone from "./Outages/Vodafone.vue";
import WesternPower from "./Outages/WesternPower.vue";

export default {
  name: "outages",
  components: {
    Ausgrid,
    CitypowerPowercor,
    EndeavourEnergy,
    Energex,
    EssentialEnergy,
    EvoEnergy,
    Optus,
    PowerWater,
    SaPowerNetworks,
    TasNetworks,
    Telstra,
    Vodafone,
    WesternPower
  },
  data () {
    return {
      error: false,
      loading: false,
      state: ""
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/state`).
      then((r) => this.state = r.data.state).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Outages.vue